import { createGlobalStyle } from 'styled-components';
export const GlobalStyles = createGlobalStyle`

*, *:before, *:after {
  box-sizing: border-box;
}

::selection{
  background-color:${({ theme }) => theme.PRIMARY_COLOR};
}

body{
  background-color:${({ theme }) => theme.TA_LIGHT};
}
.bg-overlay-dark {
  background-image:linear-gradient(0deg, ${({ theme }) => theme.SIGN_IN_BG_GRADIANT_1}, ${({ theme }) =>
	theme.SIGN_IN_BG_GRADIANT_2}),
  url('https://talentsarena.net/wp-content/uploads/2019/11/BG-Hero.jpg');
}

p{
  font-size:16px;
  font-family:'Ubuntu'
}

a,
a:hover{
  color:${({ theme }) => theme.PRIMARY_COLOR};
  text-decoration:none;
}

.perk-card:hover {
  border:${({ theme }) => `1px solid ${theme.PRIMARY_COLOR}`}
}

.ant-spin {
  color:${({ theme }) => theme.PRIMARY_COLOR}
}

.ant-spin-dot-item{
  background-color:${({ theme }) => theme.PRIMARY_COLOR}
}

.ant-table-column-sorter-up.active, .ant-table-column-sorter-down.active{
  color:${({ theme }) => theme.PRIMARY_COLOR}

}

.ant-pagination-item-active:hover a,
.ant-pagination-item:hover a,
.ant-pagination-item-active:hover,
.ant-pagination-item-active {
  border-color:${({ theme }) => theme.PRIMARY_COLOR};
  color:${({ theme }) => theme.PRIMARY_COLOR}

}

.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{
   color:${({ theme }) => theme.PRIMARY_COLOR};
}

.ant-tabs-ink-bar{
  background:${({ theme }) => theme.PRIMARY_COLOR}
}

.ant-menu-dark .ant-menu-inline.ant-menu-sub{
  background-color:${({ theme }) => theme.SIDE_SUB_MENU_BG}
}

.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color:${({ theme }) => theme.PRIMARY_COLOR}
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color:${({ theme }) => theme.PRIMARY_COLOR};
  border-color:${({ theme }) => theme.PRIMARY_COLOR}
}

.ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner, .ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color:${({ theme }) => theme.PRIMARY_COLOR}
}

.ant-checkbox-checked::after{
  border:${({ theme }) => `1px solid ${theme.PRIMARY_COLOR}`}
}

.ant-input-affix-wrapper:focus, .ant-input-affix-wrapper-focused{
  border-color:${({ theme }) => theme.PRIMARY_COLOR};
  box-shadow:${({ theme }) => `0 0 0 2px ${theme.PRIMARY_COLOR}4d`}
}

.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover{
  border-color:${({ theme }) => theme.PRIMARY_COLOR};
}

.ant-input:hover{
  border-color:${({ theme }) => theme.PRIMARY_COLOR};
}

.ant-input:focus, .ant-input-focused{
  border-color:${({ theme }) => theme.PRIMARY_COLOR};
  box-shadow:${({ theme }) => `0 0 0 2px ${theme.PRIMARY_COLOR}4d`}
}

.ant-input-number:focus, .ant-input-number-focused {
  border-color:${({ theme }) => theme.PRIMARY_COLOR};
  box-shadow:${({ theme }) => `0 0 0 2px ${theme.PRIMARY_COLOR}4d`}
}


.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector{
  border-color:${({ theme }) => theme.PRIMARY_COLOR};
  box-shadow:${({ theme }) => `0 0 0 2px ${theme.PRIMARY_COLOR}4d`}
}

.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
  border-color:${({ theme }) => theme.PRIMARY_COLOR};
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
  background:${({ theme }) => theme.PRIMARY_COLOR};
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active{
  background:${({ theme }) => theme.PRIMARY_COLOR};
  border-color:${({ theme }) => theme.PRIMARY_COLOR};

}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within{
  box-shadow:${({ theme }) => `0 0 0 2px ${theme.PRIMARY_COLOR}4d`}
}

.ant-radio-button-wrapper:hover{
  color:${({ theme }) => theme.PRIMARY_COLOR};
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover{
  background:${({ theme }) => `${theme.PRIMARY_COLOR}c9`};

}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
  border-color:${({ theme }) => theme.PRIMARY_COLOR};
}

.ant-radio-checked .ant-radio-inner{
  border-color:${({ theme }) => theme.PRIMARY_COLOR};

}

.ant-radio-checked::after,
.ant-radio-inner::after {
  background:${({ theme }) => theme.PRIMARY_COLOR};
  border:${({ theme }) => `1px solid ${theme.PRIMARY_COLOR}`}
}

.ant-radio-wrapper:hover .ant-radio, .ant-radio:hover .ant-radio-inner, .ant-radio-input:focus + .ant-radio-inner{
  box-shadow:${({ theme }) => `0 0 0 2px ${theme.PRIMARY_COLOR}4d`};
  border-color:${({ theme }) => theme.PRIMARY_COLOR};
}

.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color:${({ theme }) => `${theme.PRIMARY_COLOR}24`}
}

.ant-menu-light .ant-menu-item:hover, .ant-menu-light .ant-menu-item-active, .ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open, .ant-menu-light .ant-menu-submenu-active, .ant-menu-light .ant-menu-submenu-title:hover {
  color:${({ theme }) => theme.PRIMARY_COLOR};
}

.ant-layout-footer {
  background-color:${({ theme }) => theme.NAV_BG}
}

.ant-btn-dashed:hover, .ant-btn-dashed:focus{
  color:${({ theme }) => theme.BTN_PRIMARY_BG};
  border-color:${({ theme }) => theme.BTN_PRIMARY_BG};
}

.btn-main {
  background-color:${({ theme }) => theme.BTN_PRIMARY_BG}
}

.ant-btn-primary{
  background:${({ theme }) => theme.BTN_PRIMARY_BG};
  border-color:${({ theme }) => theme.BTN_PRIMARY_BG};
}

.ant-btn-primary:hover, .ant-btn-primary:focus,.ant-btn-primary:active{
  background:${({ theme }) => theme.BTN_PRIMARY_TXT};
  border-color:${({ theme }) => theme.BTN_PRIMARY_BG};
  color:${({ theme }) => theme.BTN_PRIMARY_BG};
}

.ant-btn-ghost:hover, .ant-btn-ghost:focus {
  background:${({ theme }) => theme.BTN_PRIMARY_TXT};
  border-color:${({ theme }) => theme.BTN_PRIMARY_BG};
  color:${({ theme }) => theme.BTN_PRIMARY_BG};
}



.react-slidedown > div {
  background-color:${({ theme }) => `${theme.PRIMARY_COLOR}0d`}
}

.ta-form .ant-btn:not(:disabled):hover, .ta-modal .ant-btn:not(:disabled):hover, .ta-form .ant-upload.ant-upload-select-picture-card:hover{
  color:${({ theme }) => theme.PRIMARY_COLOR};
  border-color:${({ theme }) => theme.PRIMARY_COLOR};
}

.ant-avatar.ant-avatar-icon{
  background:${({ theme }) => theme.PRIMARY_COLOR} !important;
}

input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: #000;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset;
  transition: background-color 50000s ease-in-out 0s;
}
`;
